import React from "react";
import myimage from "../assets/protfolio/6.jpg";
const About = () => {
  return (
    <div name="about" className="w-full h-screen  text-black">
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8 flex flex-row items-center space-x-3 text-xl">
          <p className="text-[#64ffda] font-bold">01.</p>
          <p className=" capitalize font-bold inline text-[#ccd6f6] font-serif">
            {" "}
            about me
          </p>
          <span className="w-72 border  border-cyan-900"></span>
        </div>
        <div className="grid grid-cols-12 gap-8 text-lg">
          <div className="space-y-3 text-justify col-span-7">
            <p className=" text-[#ccd6f6]">
              I am a motivated, hardworking team player with outstanding
              knowledge of cutting-edge, up-to-date web development technologies
              such as React JS, Node JS, Express JS, and Mongo DB looking for a
              web developer position in your organization. I started learning
              web development and creating static websites almost two years ago
              by following lessons on YouTube and other websites.
            </p>

            <p className=" text-[#ccd6f6]">
              I completed all of my campus projects on my own. I have gained
              work experience in this field. I am eager to gain more experience
              in this field because it complements my studies.
            </p>
            <p className=" text-[#ccd6f6]">
              I'm looking for a company that is willing to place me among their
              developers. so that I can improve my coding style while working on
              a real-world project with others. In exchange, I would give my
              undivided attention and be a pleasant and friendly addition to
              your team.
            </p>
            <p className=" text-[#ccd6f6]">
              Here are a few technologies I’ve been working with recently:
            </p>
            <ul class="list-disc text-cyan-900 grid grid-cols-2 gap-5 m-8">
              <li>JavaScript (ES6+)</li>
              <li>TypeScript</li>
              <li>React</li>
              <li>Eleventy</li>
              <li>Node.js</li>
              <li>WordPress</li>
            </ul>
          </div>
          <div className="col-span-5 relative mx-auto my-10">
            <img
              className="w-[300px] object-cover my-profile rounded-md"
              src={myimage}
              alt=""
            />
            <div className="absolute border border-[#64ffda] rounded-md w-[305px] h-[348px] z-[-1] left-4 top-5 "></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
